import { schema } from 'normalizr';
import { threadSerializer } from './thread.serializer';

export const threadSchema = new schema.Entity(
  'threads',
  {},
  {
    processStrategy: threadSerializer,
  }
);
